import { useEffect } from 'react'
import { useSetState, useLocalStorage } from 'react-use'

export const useTourToday = (showTour = false, userPreferences) => {
  const [{ run }, setState] = useSetState({
    run: false
  })
  const [hasBoardedLocal, setHasBoardedLocal] = useLocalStorage('hasBoarded')
  const hasOnboarded = Boolean(userPreferences?.account?.has_onboarded) // .account is null and .has_onboarded is undefined on first visit of the user
  const checkUserPreferences =
    userPreferences && Object.keys(userPreferences).length > 0

  useEffect(() => {
    // if never onboarded on the current device
    if (hasBoardedLocal === undefined) {
      // wait for the user preferences and showTour to be loaded
      if (checkUserPreferences && showTour) {
        hasOnboarded ? setHasBoardedLocal(true) : setState({ run: true }) // if user has onboarded set hasBoardedLocal to true for not show the tour again, else show the tour
      }
    }
    // if onboarded on the current device
    else if (hasBoardedLocal) {
      setState({ run: false }) // then don't show tour
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTour, hasOnboarded, checkUserPreferences])

  const handleClose = () => {
    setState({
      run: false
    })
  }

  const joyRideSteps = [
    {
      content: (
        <div>
          First time here? <br /> Let's show you around
        </div>
      ),
      placement: 'bottom',
      target: '#js-tour-today-title'
    },
    {
      content:
        'Search Remble to find courses and activities on a specific topic',
      placement: 'left',
      target: '#header-search-button'
    },
    {
      content:
        'Chat anonymously with Mia about improving your mental health and well-being',
      placement: 'bottom',
      target: '#js-tour-today-title'
    },
    {
      content:
        'Daily Rembles are 30-90 sec videos with therapist tips released daily',
      placement: 'top',
      target: '#js-tour-daily-remble'
    },
    {
      content:
        'Your Plan is a personalized program of courses and activities to help you reach your goals',
      placement: 'top',
      target: '#js-tour-user-plan'
    },
    {
      content: (
        <div>
          <p>Ready to start?</p>
          <button className='btn btn-primary w-100' onClick={handleClose}>
            I’m ready!
          </button>
        </div>
      ),
      hideFooter: true,
      placement: 'bottom',
      target: '#js-tour-today-title'
    }
  ]

  const joyRideProps = {
    disableBeacon: true,
    disableOverlayClose: true,
    showSkipButton: true,
    disableScrolling: false,
    disableScrollParentFix: true,
    hideCloseButton: true,
    styles: {
      options: {
        zIndex: 10000
      }
    }
  }

  return {
    run,
    joyRideProps,
    joyRideSteps
  }
}
